import React, { useState } from 'react'
import Html from './html';

export default function Form({ props, translations }) {
    const { formType } = props;
    const message = translations?.message || props?.message
    const labels = {
        bot: translations ? "No rellenes esto si eres humano" : "Don’t fill this out if you’re human",
        firstName: translations ? "Nombre de pila" : "First name",
        lastName: translations ? "Apellido" : "Last name",
        email: translations ? "Correo electrónico" : "Email address",
        phone: translations ? "Teléfono" : "Phone",
        county: translations ? "Condado" : "County",
        message: translations ? "Mensaje" : "Message",
        submit: translations ? "Enviar" : "Submit",
        individualName: translations ? "Nombre del individuo que completó la verificación de antecedentes" : "Name of Individual Who Completed Background Check",
        physicalAddress: translations ? "Dirección física del individuo que completó la verificación de antecedentes" : "Physical Address of Individual Who Completed Background Check",
        addressLine1: translations ? "Dirección" : "Street Address",
        addressLine2: translations ? "Apartamento, Suite, Edificio (Opcional)" : "Apt, Suite, Building (Optional)",
        city: translations ? "Ciudad" : "City",
        state: translations ? "Estado" : "State",
        zip: translations ? "Código postal" : "Zip",
        childCareSettings: translations ?
            [
                "Centro de cuidado infantil con licencia",
                "Cuidado infantil familiar o cuidado infantil grupal con licencia",
                "Programa de tiempo libre o programa de recreación fuera del horario escolar",
                "Proveedor de FFN",
                "Miembro del hogar de un proveedor de cuidado infantil familiar, de grupo o de FFN",
            ]
            : [
                "Licensed Child Care Center",
                "Licensed Family Child Care or Group Family Child Care",
                "Out-of-School Time or Out-of-School Recreation Program",
                "FFN provider",
                "Household Member of a Family Child Care, Group Family Child Care or FFN provider",
            ],
        childCareSettingsLegend: translations ? "Seleccione el tipo de entorno de cuidado infantil en el que trabaja el individuo."
            : "Select the type of child care setting in which the individual works.",
        childCareSettingsDescription: translations ? "Si el individuo es un miembro del hogar de un proveedor de cuidado infantil familiar, de grupo o de familia y amigos (FFN), seleccione la opción Miembro del hogar."
            : " If the individual is a household member of a Family Child Care, Group Family Child Care or Family, Friend and Neighbor (FFN) provider, please select the Household Member option.",
        whoPaidLegend: translations ?
            "Indique quién pagó por la verificación de antecedentes y las tarifas de rodaje de esta persona."
            : 'Indicate who paid for this individual’s background check and rolling fee.',
        whoPaidDescription: translations ?
            "IMPORTANTE! El reembolso se hará a la empresa o persona a continuación. Es fundamental que toda la información sea precisa."
            : "IMPORTANT! The reimbursement will be made out to the business or individual below. It is critical that all information is accurate.",
        whoPaidOptions: translations ?
            [
                "La persona que completó la verificación de antecedentes mencionada anteriormente pagó por la verificación de antecedentes y las tarifas de rodaje",
                "El negocio de cuidado infantil pagó las tarifas de verificación de antecedentes de esta persona y será reembolsado por esta persona."
            ]
            : [
                "The individual who completed the background check listed above paid for the background check and rolling fees",
                "The child care business paid for this individual’s background check fees and will be reimbursed for this individual."
            ],
        differentMailingAddress: translations ?
            "La dirección postal es diferente de la dirección física anterior" :
            "Mailing address is different from physical address above",
        mailingName: translations ?
            "La dirección postal - Nombre del negocio o individuo" :
            "Mailing Address - Name of Business or Individual",
        type: translations ?
            "Seleccione el tipo de verificación de antecedentes para la que está solicitando un reembolso." :
            "Select the type of background check you are requesting reimbursement for.",
        typeOptions: translations ?
            ["Verificación de antecedentes iniciales",
                "Verificación de antecedentes de renovación"] :
            ["Initial Background Check",
                "Renewal Background Check"],
        amountPaid: translations ?
            "Cantidad total pagada por la verificación de antecedentes y las tarifas de rodaje de esta persona:" :
            "Total amount paid for this individual’s background check and rolling fee (if applicable):",
        upload: translations ?
            "CARGAR: Cargue todos los recibos. Los recibos deben totalizar la cantidad solicitada. Tamaño máximo de archivo de 8 MB por envío." :
            "REQUIRED: Upload all receipts. Receipts must total the amount requested. 8 MB max file size per submission."

    }
    return (
        <section className="bg-blue-50">
            <div className={`container pt-12 pb-16`}>
                <div className={` ${formType === "contact" ? "max-w-md text-center mx-auto" : "max-w-6xl"}`}>
                    {message ?
                        <Html className="leading-relaxed mb-8 parsed-content">{message}</Html>
                        : null}
                    {formType === "contact" ?
                        <ContactForm labels={labels} />
                        : formType === "backgroundCheck" ?
                            <BackgroundCheckForm labels={labels} locale={translations ? "es" : "en"} />
                            : null}
                </div>
            </div>
        </section>
    )
}

function BackgroundCheckForm({ labels }) {
    const whoPaidOptions = [
        "The individual who completed the background check listed above paid for the background check and rolling fees",
        "The child care business paid for this individual’s background check fees and will be reimbursed for this individual."
    ]
    const [whoPaid, setWhoPaid] = useState(null);
    const [differentMailingAddress, setDifferentMailingAddress] = useState(false);
    const fileUpload = [1, 2, 3, 4, 5]
    const [fileUploadCount, setFileUploadCount] = useState(1);
    const mailingAddressRequired = (whoPaid === whoPaidOptions[0] && differentMailingAddress) || whoPaid === whoPaidOptions[1]
    return <form
        netlify-honeypot="bot-field"
        data-netlify="true"
        encType="multipart/form-data"
        name="Background Check Reimbursement Request"
        action="/background-check-reimbursement-request/thank-you/"
        method="POST"
        className="grid grid-cols-1 gap-y-6 leading-normal">
        <input type="hidden" name="form-name" value="Background Check Reimbursement Request" />
        <p className="hidden">
            <label>
                {labels.bot} <input name="bot-field" />
            </label>
        </p>
        <NameFields label={labels.individualName} includeEmail={true} labels={labels} />
        <AddressFields name={'Physical Address'} label={labels.physicalAddress} labels={labels} />
        <fieldset className="border-t border-t-blue-300 pt-5 grid gap-2">
            <p><legend className="font-bold">{labels.childCareSettingsLegend}</legend>{labels.childCareSettingsDescription}</p>
            {labels.childCareSettings.map((option) => (
                <>
                    {option ?
                        <RadioOption option={option} name="Child Care Setting" />
                        : null}
                </>
            ))}
        </fieldset>
        <fieldset className="border-t border-t-blue-300 pt-5 grid gap-4">
            <p><legend className="font-bold">{labels.whoPaidLegend}</legend><span className="italic">{labels.whoPaidDescription}</span></p>
            <RadioOption onChange={(e) => { setWhoPaid(e.target.value); }} option={whoPaidOptions[0]} name="Who Paid" label={labels.whoPaidOptions[0]}>
                <div className={`w-full flex-grow pl-4 sm:pl-6 pt-2 ${whoPaid === whoPaidOptions[0] ? "" : "hidden"}`}>
                    <label className="flex">
                        <input
                            className="rounded-md text-blue-900 mr-1.5 mt-1"
                            type="checkbox"
                            name="Different Mailing Address"
                            onChange={(e) => { setDifferentMailingAddress(e.target.checked); }}
                            value={differentMailingAddress}
                            checked={differentMailingAddress}
                        />
                        {labels.differentMailingAddress}
                    </label>
                </div>
            </RadioOption>
            <RadioOption onChange={(e) => { setWhoPaid(e.target.value); }} option={whoPaidOptions[1]} name="Who Paid" label={labels.whoPaidOptions[1]} />
            <div className={`w-full flex-grow pl-4 grid gap-4 ${(whoPaid === whoPaidOptions[0] && differentMailingAddress) ? "row-start-3 sm:pl-12" : whoPaid === whoPaidOptions[1] ? "sm:pl-6" : "hidden"}`}>
                <label>
                    <span className="sr-only">
                        {labels.mailingName}
                    </span>
                    <input
                        type="text"
                        name={`Mailing Name`}
                        required={mailingAddressRequired}
                        autoComplete="name"
                        className="form-field"
                        placeholder={labels.mailingName} />
                </label>
                <AddressFields name={'Mailing Address'} required={mailingAddressRequired} labels={labels} />
            </div>
        </fieldset>
        <fieldset className="border-t border-t-blue-300 pt-5 grid gap-2">
            <p><legend className="font-bold">{labels.type}</legend></p>
            {labels.typeOptions.map((option) => (
                <>
                    {option ?
                        <RadioOption option={option} name="Background Check Type" />
                        : null}
                </>
            ))}
        </fieldset>
        <div className="border-t border-t-blue-300 pt-4 flex items-center flex-wrap">
            <label>
                <span className="font-bold inline-block mr-2 my-1">
                    {labels.amountPaid}
                </span>
                <input
                    type="text"
                    name='Amount Paid'
                    className="form-field w-56 my-1"
                />
            </label>
        </div>
        <div className="bg-white p-7 rounded-md mb-4">
            <p className="mb-4 font-bold">{labels.upload}</p>
            {fileUpload.map(
                (fileUploadOption, index) => (
                    <label className={`block my-4 ${fileUploadCount > index ? "" : "hidden"}`}>
                        <span className="sr-only">File {fileUploadOption}</span>
                        <input required={index === 0 ? true : false} type="file" name={`File ${fileUploadOption}`}
                            onChange={(e) => {
                                setFileUploadCount((e.target.files.length > 0) ? fileUploadCount + 1 : fileUploadCount - 1);
                            }}
                            className={`bg-blue-50 w-96 max-w-full rounded-md file:mr-2 file:bg-blue-400 file:py-2 file:px-3 pr-2 file:transition cursor-pointer file:cursor-pointer file:hover:bg-blue-500 file:hover:text-navy file:text-navy file:font-bold file:border-none file:rounded-md`}
                        />
                    </label>
                )
            )}
        </div>

        <div className="text-left">
            <button
                type="submit"
                className="btn btn-primary focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2"
            >
                {labels.submit}
            </button>
        </div>
    </form>;
}


function NameFields({ name, label, includeEmail = false, labels }) {
    return <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="col-span-full font-bold">{label}</div>
        <label className="block">
            <span className="sr-only">
                {labels.firstName}
            </span>
            <input
                type="text"
                name={`${name ? name + " " : ""}First Name`}
                required
                autoComplete="given-name"
                className="form-field"
                placeholder={labels.firstName} />
        </label>
        <label className="block">
            <span className="sr-only">
                {labels.lastName}
            </span>
            <input
                type="text"
                name={`${name ? name + " " : ""}Last Name`}
                required
                autoComplete="family-name"
                className="form-field"
                placeholder={labels.lastName} />
        </label>
        {includeEmail ?
            <label className="block">
                <span className="sr-only">
                    {labels.email}
                </span>
                <input
                    type="email"
                    name={`Email`}
                    required
                    autoComplete="email"
                    className="form-field"
                    placeholder={labels.email} />
            </label> : null}
        <label className="block">
            <span className="sr-only">
                {labels.phone}
            </span>
            <input
                type="tel"
                name={`Phone`}
                required
                autoComplete="tel"
                className="form-field"
                placeholder={labels.phone} />
        </label>
    </div>;
}

function AddressFields({ name, label, required = true, labels }) {
    return <div className="grid sm:grid-cols-3 gap-4">
        {label ? <div className="col-span-full font-bold">{label}</div> : null}
        <label className="block col-span-full">
            <span className="sr-only">
                {labels.addressLine1}
            </span>
            <input placeholder={labels.addressLine1} className="form-field" name={`${name} Line 1`} autoComplete="address-line1" required={required}></input>
        </label>
        <label className="col-span-full">
            <span className="sr-only">
                {labels.addressLine2}
            </span>
            <input placeholder={labels.addressLine2} className="form-field" name={`${name} Line 2`} autoComplete="address-line2"></input>
        </label>
        <label>
            <span className="sr-only">
                {labels.city}
            </span>
            <input placeholder={labels.city} type="text" className="form-field" name={`${name} City`} required={required} />
        </label>
        <label>
            <span className="sr-only">
                {labels.state}
            </span>
            <select
                name={`${name} State`}
                className="form-field"
                autoComplete="state"
                required={required}
            >
                {states.map((state) => (
                    <option
                        key={state.value}
                        value={state.value}
                    >
                        {state.label === "State" ? labels.state : state.label}
                    </option>
                ))}
            </select>
        </label>

        <div>
            <span className="sr-only">
                {labels.zip}
            </span>
            <input placeholder={labels.zip} type="text" className="form-field" name={`${name} Zip`} autoComplete="postal-code" required={required} />
        </div>
    </div>;
}

function RadioOption({ option, name, children, onChange, label }) {
    return <div>
        <label className="flex">
            <input
                type="radio"
                className="text-blue-900 mr-1.5 mt-1 rounded-md"
                name={name}
                required
                value={option}
                onChange={onChange}
            >
            </input>
            <div className="block">
                {label || option}
            </div>
        </label>
        {children}
    </div>;
}

function ContactForm({ labels }) {
    return <form
        netlify-honeypot="bot-field"
        data-netlify="true"
        name="contact"
        action="/contact/thank-you"
        method="POST"
        className="grid grid-cols-1 gap-y-5">
        <input type="hidden" name="form-name" value="contact" />
        <p className="hidden">
            <label>
                {labels.bot} <input name="bot-field" />
            </label>
        </p>
        <div>
            <label htmlFor="first-name" className="sr-only">
                {labels.firstName}
            </label>
            <input
                type="text"
                name="first-name"
                id="first-name"
                required
                autoComplete="given-name"
                className="form-field"
                placeholder={labels.firstName} />
        </div>
        <div>
            <label htmlFor="last-name" className="sr-only">
                {labels.lastName}
            </label>
            <input
                type="text"
                name="last-name"
                id="last-name"
                required
                autoComplete="family-name"
                className="form-field"
                placeholder={labels.lastName} />
        </div>
        <div>
            <label htmlFor="email" className="sr-only">
                {labels.email}
            </label>
            <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                className="form-field"
                placeholder={labels.email} />
        </div>
        <div>
            <label htmlFor="phone" className="sr-only">
                {labels.phone}
            </label>
            <input
                id="phone"
                name="phone"
                required
                type="tel"
                autoComplete="tel"
                className="form-field"
                placeholder={labels.phone} />
        </div>
        <div>
            <label htmlFor="county" className="sr-only">{labels.county}</label>
            <select name="county" id="county" required className='form-field'>
                <option value="">{labels.county}</option>
                <option value="Carson City">Carson City</option>
                <option value="Churchill County">Churchill County</option>
                <option value="Clark County">Clark County</option>
                <option value="Douglas County">Douglas County</option>
                <option value="Elko County">Elko County</option>
                <option value="Esmeralda County">Esmeralda County</option>
                <option value="Eureka County">Eureka County</option>
                <option value="Humboldt County">Humboldt County</option>
                <option value="Lander County">Lander County</option>
                <option value="Lincoln County">Lincoln County</option>
                <option value="Lyon County">Lyon County</option>
                <option value="Mineral County">Mineral County</option>
                <option value="Nye County">Nye County</option>
                <option value="Pershing County">Pershing County</option>
                <option value="Storey County">Storey County</option>
                <option value="Washoe County">Washoe County</option>
                <option value="White Pine County">White Pine County</option>
            </select>
        </div>
        <div>
            <label htmlFor="message" className="sr-only">
                {labels.message}
            </label>
            <textarea
                id="message"
                name="message"
                rows={4}
                className="form-field"
                placeholder={labels.message}
                defaultValue={''} />
        </div>
        <div className="text-left">
            <button
                type="submit"
                className="btn btn-primary focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2"
            >
                {labels.submit}
            </button>
        </div>
    </form>;
}

const states = [
    { value: '', label: 'State' },
    { value: 'AL', label: 'Alabama' },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
    { value: "DC", label: "Washington DC" },
    { value: "AE", label: "ARMED FORCES AFRICA CANADA EUROPE MIDDLE EAST" },
    { value: "AA", label: "ARMED FORCES AMERICA (EXCEPT CANADA)" },
    { value: "AP", label: "ARMED FORCES PACIFIC" },
]